import {Form, message} from 'antd';
import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useHistory, useRouteMatch} from 'react-router';
import ActionBar from '../../../../components/action-bar';
import ActionButton from '../../../../components/action-button';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import { cabecalhoSelector, fetchContratos, fetchLivrosDigitais } from '../../../../store/empresa';
import {valuesToFormData} from '../../../../util/formData';
import unwrapAxiosPromise from '../../../../util/unwrapAxiosPromise';
import EmpresaContratoForm from './_form';
import useModulo from "../../../../hooks/useModulo";

export default function EmpresaContratoCreatePage() {
  const {t} = useTranslation();
  const dispatch = useDispatchWithResult();
  const [form] = Form.useForm();
  const cabecalho = useSelector(cabecalhoSelector);
  const [loadingSave, setLoadingSave] = useState(false);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const {moduloBasePath} = useModulo();

  useEffect(() => {
    form.resetFields();
    setImmediate(() => document.querySelector('#nomeAto').focus());
  }, []);

  const handleFinish = values => {
    setLoadingSave(true);
    const formData = valuesToFormData(values);
    unwrapAxiosPromise(axios.post(`/empresas/${empresaId}/contratos`, formData), form)
        .then(data => {
          message.success(t('Registro incluído com sucesso'));
          history.replace(`${moduloBasePath}/empresas/${empresaId}/contratos`);
          dispatch(fetchContratos({empresaId}));
          dispatch(fetchLivrosDigitais({empresaId}));
        })
        .finally(() => setLoadingSave(false));
  };

  const handleCancel = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/contratos`);
  };

  const title = (
      <ActionBar>
        <ActionButton.Save onClick={form.submit} loading={loadingSave} />
        <ActionButton.Cancel onClick={handleCancel} disabled={loadingSave} />
      </ActionBar>);

  return (
      <EmpresaContratoForm
          disabled={loadingSave}
          empresaId={empresaId}
          cabecalho={cabecalho}
          form={form}
          onFinish={handleFinish}
          title={title}
      />);
}
